import type { NotificationFormAnonymousData } from './notificationFormAnonymous.d';
import React from 'react';
import { NotificationFormAnonymous } from '/react4xp/parts/notificationFormAnonymous/NotificationFormAnonymous';


export default function (props: { data: NotificationFormAnonymousData }): JSX.Element {
	return <NotificationFormAnonymous {...props} />;
}
